import React from 'react';
import './Badge.css';

/**
 * Badge Component
 *
 * @param {string} variant - 'default' | 'success' | 'warning' | 'error' | 'info' | 'primary'
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {boolean} dot - Show dot indicator
 * @param {string} status - Predefined status: 'new' | 'preparing' | 'ready' | 'delivered' | 'cancelled' | 'pending' | 'paid' | 'settled' | 'active' | 'inactive'
 */
const Badge = ({
  children,
  variant = 'default',
  size = 'md',
  dot = false,
  status,
  className = '',
  ...props
}) => {
  // Map status to variant
  const statusVariantMap = {
    'new': 'info',
    'preparing': 'warning',
    'in_progress': 'warning',
    'ready': 'success',
    'prepared': 'success',
    'out_for_delivery': 'info',
    'delivered': 'success',
    'completed': 'success',
    'cancelled': 'error',
    'rejected': 'error',
    'pending': 'warning',
    'paid': 'success',
    'settled': 'success',
    'active': 'success',
    'inactive': 'default',
    'online': 'success',
    'offline': 'error',
    'cod': 'warning',
    'delivery': 'info',
    'pickup': 'primary',
    'takeaway': 'primary',
    'veg': 'success',
    'non-veg': 'error'
  };

  const finalVariant = status ? statusVariantMap[status.toLowerCase()] || 'default' : variant;

  const classNames = [
    'oz-badge',
    `oz-badge--${finalVariant}`,
    `oz-badge--${size}`,
    dot && 'oz-badge--dot',
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={classNames} {...props}>
      {dot && <span className="oz-badge__dot" />}
      <span className="oz-badge__text">{children}</span>
    </span>
  );
};

export default Badge;
